import React from 'react'
import '../styles/Credit.scss';

export default function Credit() {
    return (
      <div className="CreditContainer">
        <h5>Welcome to Credit</h5>
        <br />
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos cum odit est porro placeat architecto praesentium dolores suscipit excepturi iure vel ipsam, tenetur aut consectetur voluptatum labore!</p>
      </div>
    );
}
